import { http } from 'services/http';
import { COMMENTS_GET_MANY } from 'api/query-keys.ts';
import type { TCommentRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useDeleteComment = () => {
  return useMutationBase<TCommentRes, unknown, { commentId: number }>({
    mutationFn: async (variables) => {
      const res = await http.delete<TCommentRes>(`/v1/comments/${variables.commentId}`);

      return res.data;
    },

    invalidateCallback: () => [[COMMENTS_GET_MANY]],
  });
};
